// black
export const black1 = '#000000';
export const black2 = '#1e2940';

// white
export const white = '#FFF';

// greens
export const green1 = '#0F995F';
export const green2 = '#11AA5B';
export const green3 = '#5CCC9D';
export const green4 = '#8FDBBB';
export const green5 = '#CEEBDF';
export const green6 = '#E6F7F0';
export const green7 = '#06391E';
export const green8 = '#0E8E4C';
export const green9 = '#39BB78';
export const green10 = '#EEFCF5';
export const green11 = '#8BD9B0';
export const green12 = '#f1fce9';
export const green13 = '#02810f';
export const green14 = '#EEFCF5';
export const green15 = '#0C8E4C';
export const green16 = '#fafdfb';
export const green17 = '#13aa5b';
export const green18 = '#00810F';
export const green19 = '#F1FCE9';
export const green20 = '#1E3522';
export const green21 = '#0E1A0F';
export const green22 = '#F7FCF9';
export const green23 = '#B6EBCF';
export const green24 = '#7EC256';
export const green25 = '#2E8558';

// blues
export const blue1 = '#3369D4';
export const blue2 = '#5185EC';
export const blue3 = '#7CA8FF';
export const blue4 = '#B2CCFF';
export const blue5 = '#D0E0FF';
export const blue6 = '#E8EFFC';
export const blue7 = '#e6f8f9';
export const blue8 = '#007e8a';
export const blue9 = '#E8EFFD';
export const blue10 = '#3369D4';
export const blue11 = '#234A96';

// yellows
export const yellow1 = '#D69513';
export const yellow2 = '#E5AC39';
export const yellow3 = '#F0C267';
export const yellow4 = '#F2D69D';
export const yellow5 = '#FAE5BC';
export const yellow6 = '#FCF2DC';
export const yellow7 = '#FFBF3D';
export const yellow8 = '#fff4df';
export const yellow9 = '#c4b40b';
export const yellow10 = '#FFF4DF';
export const yellow11 = '#CC7B01';
export const yellow12 = '#fff9ef';
export const yellow13 = '#8B610D';
export const yellow14 = '#ECB23E';
export const yellow15 = '#FFE4AF';

// oranges
export const orange1 = '#FC5603';
export const orange2 = '#FFE6D9';
export const orange3 = '#FEF7F6';
export const orange4 = '#EE7752';
export const orange5 = '#8B3F2C';

// reds
export const red1 = '#C4254D';
export const red2 = '#DF3C64';
export const red3 = '#FA6489';
export const red4 = '#F09CB1';
export const red5 = '#F2DAE0';
export const red6 = '#FFF2F5';
export const red7 = '#DF3B6414';
export const red8 = '#DF3B64';
export const red9 = '#fff2f5';
export const red10 = '#fb6489';
export const red11 = '#cc7b01';
export const red12 = '#ffeeef';
export const red13 = '#ea3700';
export const red14 = '#ffeeef';
export const red15 = '#ea3700';
export const red16 = '#8B1B36';
export const red17 = '#fffafa';
export const red18 = '#6B1528';
export const red19 = '#AF2C4D';
export const red20 = '#B1280F';
export const red21 = '#FFEEEE';
export const red22 = '#FFE1E9';

// grays
export const gray1 = '#1C1E21';
export const gray2 = '#242629';
export const gray3 = '#3D3F45';
export const gray4 = '#5E6470';
export const gray5 = '#818896';
export const gray6 = '#B7BCC7';
export const gray7 = '#DADDE5';
export const gray8 = '#F0F2F5';
export const gray9 = '#F7F8FA';
export const gray10 = '#1B273E';
export const gray11 = '#5B677E';
export const gray12 = '#0F1B32';
export const gray13 = '#CBD1DB';
export const gray14 = '#E8ECF2';
export const gray15 = '#F6F7FA';
export const gray16 = '#34415A';
export const gray17 = '#818B9D';
export const gray18 = '#0e1b32';

// teal
export const teal1 = '#00565A';
export const teal2 = '#007E8A';
export const teal3 = '#00BECC';
export const teal4 = '#A4E8EC';
export const teal5 = '#E3FDFF';
export const teal6 = '#26344E';
export const teal7 = '#F4FAFA';

// purple
export const purple1 = '#4B17A1';
export const purple2 = '#7E23F1';
export const purple3 = '#AF81F8';
export const purple4 = '#D8C0FF';
export const purple5 = '#F0E6FD';
export const purple6 = '#f1e6fd';
export const purple7 = '#4b17a1';
export const purple8 = '#F5F2FC';
export const purple9 = '#8863D8';
export const purple10 = '#A77EE8';

// magenta
export const magenta1 = '#7E1F80';
export const magenta2 = '#B600C7';
export const magenta3 = '#FD83FF';
export const magenta4 = '#FEBBFF';
export const magenta5 = '#FFE3FF';

// Primary
export const primaryBlue = blue2;
export const primaryGreen = green2;
export const primaryRed = red2;
export const primaryYellow = yellow2;

// Top bar
export const topBarDark = '#121314';

/**
 * This color palette will eventually replace all of the colors above
 * in this file.
 *
 * Do not export and use this color palette directly.
 *
 * Expose these colors through the porticoThemeColors object instead
 * to allow for easier color changes in the future.
 */
const porticoColors = {
  black: '#000000',
  blue: {
    50: '#DDEDF3',
    200: '#73CAE7',
    300: '#4298B5',
    400: '#197391',
    500: '#006B8F',
    600: '#005C7A',
    700: '#004961',
  },
  golden: {
    50: '#FFF6E5',
    200: '#FFC157',
    300: '#FFA300',
    400: '#E08600',
    500: '#C97900',
    600: '#A66400',
    700: '#794E04',
  },
  neutral: {
    100: '#F6F6F6',
    200: '#EBEAE8',
    300: '#CECCCA',
    350: '#C9C7C5',
    400: '#9E9994',
    500: '#6C6762',
    600: '#5E5955',
    700: '#4E4A46',
    800: '#2D2B29',
    900: '#201F1D',
    1000: '#212721',
  },
  pinkish: {
    50: '#F6E4EF',
    200: '#DA91BC',
    300: '#C6579A',
    400: '#B64086',
    500: '#9C3673',
    600: '#762857',
    700: '#4C1A38',
  },
  red: {
    50: '#F9E2E5',
    200: '#E78E9C',
    300: '#DB566D',
    400: '#CD3D56',
    500: '#B2364B',
    600: '#962337',
    700: '#831D2E',
  },
  teal: {
    50: '#DDF3ED',
    200: '#99E3D7',
    300: '#00AB8E',
    400: '#00856F',
    500: '#046353',
    600: '#003A30',
    700: '#002721',
  },
  vibrantTerracotta: {
    50: '#FBE8E4',
    200: '#ED9B8C',
    300: '#E56A54',
    400: '#CF4F38',
    500: '#BA422D',
    600: '#A23522',
    700: '#7B2717',
  },
  white: '#FFFFFF',
};

/**
 * Color palette for Learnosity (assessment feature).
 */
const learnosityColors = {
  error: {
    background: {
      dark: '#FBE3E2',
      light: '#FBE3E2',
    },
    foreground: {
      dark: '#DD002F',
      light: '#DD002F',
    },
  },
  success: {
    background: {
      dark: '#EFF8ED',
      light: '#EFF8ED',
    },
    foreground: {
      dark: '#49700B',
      light: '#49700B',
    },
  },
  warning: {
    background: {
      dark: '#414124',
      light: '#FCFCD3',
    },
    foreground: {
      dark: '#888888',
      light: '#888888',
    },
  },
};

const paymentColors = {
  blue: {
    background: {
      dark: porticoColors.blue[400],
      light: porticoColors.blue[50],
    },
    foreground: {
      dark: porticoColors.white,
      light: porticoColors.blue[600],
    },
  },
  coral: {
    background: {
      dark: porticoColors.vibrantTerracotta[600],
      light: porticoColors.vibrantTerracotta[50],
    },
    foreground: {
      dark: porticoColors.white,
      light: porticoColors.vibrantTerracotta[500],
    },
  },
  neutral: {
    background: {
      dark: porticoColors.neutral[500],
      light: porticoColors.neutral[200],
    },
    foreground: {
      dark: porticoColors.white,
      light: porticoColors.neutral[700],
    },
  },
  pink: {
    background: {
      dark: porticoColors.pinkish[500],
      light: porticoColors.pinkish[50],
    },
    foreground: {
      dark: porticoColors.white,
      light: porticoColors.pinkish[600],
    },
  },
  red: {
    background: {
      dark: porticoColors.red[500],
      light: porticoColors.red[50],
    },
    foreground: {
      dark: porticoColors.white,
      light: porticoColors.red[500],
    },
  },
  teal: {
    background: {
      dark: porticoColors.teal[400],
      light: porticoColors.teal[50],
    },
    foreground: {
      dark: porticoColors.white,
      light: porticoColors.teal[500],
    },
  },
  yellow: {
    background: {
      dark: porticoColors.golden[300],
      light: porticoColors.golden[50],
    },
    foreground: {
      dark: porticoColors.neutral[900],
      light: porticoColors.golden[500],
    },
  },
};

/**
 * Can be used directly by importing where needed, or through the
 * Theme object of MUI. See muiTheme.tsx for more details.
 */
export const porticoThemeColors = {
  alert: {
    dark: {
      main: porticoColors.vibrantTerracotta[300],
    },
    light: {
      main: porticoColors.vibrantTerracotta[300],
    },
  },
  background: {
    dark: porticoColors.neutral[900],
    light: porticoColors.neutral[200],
  },
  black: porticoColors.black,
  buttonContained: {
    error: {
      hover: {
        dark: porticoColors.red[200],
        light: porticoColors.red[500],
      },
    },
    primary: {
      hover: {
        dark: porticoColors.teal[200],
        light: porticoColors.teal[500],
      },
    },
  },
  buttonOutline: {
    dark: porticoColors.neutral[400],
    light: porticoColors.neutral[600],
  },
  card: {
    dark: porticoColors.neutral[800],
    light: porticoColors.neutral[100],
  },
  divider: {
    dark: porticoColors.neutral[700],
    light: porticoColors.neutral[300],
  },
  error: {
    dark: porticoColors.red[300],
    light: porticoColors.red[400],
  },
  errorBackground: {
    dark: porticoColors.red[500],
    light: porticoColors.red[50],
  },
  errorForeground: {
    dark: porticoColors.red[50],
    light: porticoColors.red[500],
  },
  fill: {
    dark: {
      error: {
        backgroundColor: porticoColors.red[500],
        color: porticoColors.red[300],
      },
      primary: {
        backgroundColor: porticoColors.teal[500],
        color: porticoColors.teal[300],
      },
      secondary: {
        backgroundColor: porticoColors.blue[500],
        color: porticoColors.blue[300],
      },
      warning: {
        backgroundColor: porticoColors.golden[500],
        color: porticoColors.golden[300],
      },
    },
    light: {
      error: {
        backgroundColor: porticoColors.red[50],
        color: porticoColors.red[300],
      },
      primary: {
        backgroundColor: porticoColors.teal[50],
        color: porticoColors.teal[300],
      },
      secondary: {
        backgroundColor: porticoColors.blue[50],
        color: porticoColors.blue[300],
      },
      warning: {
        backgroundColor: porticoColors.golden[50],
        color: porticoColors.golden[300],
      },
    },
  },
  icon: {
    dark: porticoColors.neutral[300],
    light: porticoColors.neutral[700],
  },
  input: {
    dark: {
      background: porticoColors.neutral[800],
      border: porticoColors.neutral[600],
    },
    light: {
      background: porticoColors.neutral[100],
      border: porticoColors.neutral[600],
    },
  },
  inputField: {
    dark: porticoColors.neutral[600],
    light: porticoColors.neutral[400],
  },
  learnosity: {
    error: {
      background: {
        dark: learnosityColors.error.background.dark,
        light: learnosityColors.error.background.light,
      },
      foreground: {
        dark: learnosityColors.error.foreground.dark,
        light: learnosityColors.error.foreground.light,
      },
    },
    success: {
      background: {
        dark: learnosityColors.success.background.dark,
        light: learnosityColors.success.background.light,
      },
      foreground: {
        dark: learnosityColors.success.foreground.dark,
        light: learnosityColors.success.foreground.light,
      },
    },
    warning: {
      background: {
        dark: learnosityColors.warning.background.dark,
        light: learnosityColors.warning.background.light,
      },
      foreground: {
        dark: learnosityColors.warning.foreground.dark,
        light: learnosityColors.warning.foreground.light,
      },
    },
  },
  login: {
    backgroundColor: {
      dark: porticoColors.neutral[1000],
      light: porticoColors.neutral[100],
    },
  },
  neutral: {
    dark: {
      background: porticoColors.neutral[500],
      foreground: porticoColors.white,
    },
    light: {
      background: porticoColors.neutral[200],
      foreground: porticoColors.neutral[700],
    },
  },
  nudgeChannel: {
    backgroundColor: {
      dark: porticoColors.pinkish[400],
      light: porticoColors.pinkish[50],
    },
    borderColor: {
      dark: porticoColors.pinkish[200],
      light: porticoColors.pinkish[300],
    },
    iconColor: {
      dark: porticoColors.pinkish[200],
      light: porticoColors.pinkish[300],
    },
  },
  nudgeDashboard: {
    dark: {
      categoryRate: {
        description: porticoColors.neutral[500],
        negative: porticoColors.red[300],
        positive: porticoColors.teal[500],
      },
      channelDistribution: {
        neutral: porticoColors.neutral[100],
      },
      channelStats: {
        negative: porticoColors.red[300],
        neutral: porticoColors.neutral[400],
        positive: porticoColors.teal[300],
      },
      charts: {
        blue: porticoColors.blue[300],
        golden: porticoColors.golden[300],
        neutral: porticoColors.neutral[700],
        pink: porticoColors.pinkish[200],
        red: porticoColors.red[300],
        teal: porticoColors.teal[300],
        vibrantTerracotta: porticoColors.vibrantTerracotta[300],
      },
      dateRange1: {
        backgroundColor: porticoColors.vibrantTerracotta[300],
        circle: porticoColors.vibrantTerracotta[300],
        color: porticoColors.neutral[900],
        description: porticoColors.neutral[300],
      },
      dateRange2: {
        backgroundColor: porticoColors.teal[300],
        circle: porticoColors.teal[300],
        color: porticoColors.neutral[900],
        description: porticoColors.neutral[300],
      },
      filters: {
        icon: porticoColors.neutral[400],
      },
      performanceComparison: {
        backgroundColor: porticoColors.neutral[700],
        color: porticoColors.neutral[600],
        title: porticoColors.neutral[100],
      },
      tables: {
        backgroundColor: porticoColors.neutral[700],
        color: porticoColors.neutral[300],
      },
      weekOverWeek: {
        active: {
          background: porticoColors.neutral[800],
          border: porticoColors.white,
          percentage: porticoColors.red[300],
          text: porticoColors.neutral[400],
          title: porticoColors.neutral[100],
          total: porticoColors.neutral[100],
        },
        inactive: {
          background: porticoColors.neutral[900],
          border: porticoColors.neutral[900],
          percentage: porticoColors.teal[300],
          text: porticoColors.neutral[400],
          title: porticoColors.neutral[400],
          total: porticoColors.neutral[400],
        },
      },
    },
    light: {
      categoryRate: {
        description: porticoColors.neutral[500],
        negative: porticoColors.red[300],
        positive: porticoColors.teal[500],
      },
      channelDistribution: {
        neutral: porticoColors.neutral[900],
      },
      channelStats: {
        negative: porticoColors.red[300],
        neutral: porticoColors.neutral[700],
        positive: porticoColors.teal[500],
      },
      charts: {
        blue: porticoColors.blue[300],
        golden: porticoColors.golden[300],
        neutral: porticoColors.neutral[200],
        pink: porticoColors.pinkish[200],
        red: porticoColors.red[300],
        teal: porticoColors.teal[300],
        vibrantTerracotta: porticoColors.vibrantTerracotta[300],
      },
      dateRange1: {
        backgroundColor: porticoColors.blue[50],
        circle: porticoColors.blue[600],
        color: porticoColors.blue[600],
        description: porticoColors.neutral[700],
      },
      dateRange2: {
        backgroundColor: porticoColors.teal[50],
        circle: porticoColors.teal[500],
        color: porticoColors.teal[500],
        description: porticoColors.neutral[700],
      },
      filters: {
        icon: porticoColors.neutral[600],
      },
      performanceComparison: {
        backgroundColor: porticoColors.neutral[200],
        color: porticoColors.neutral[900],
        title: porticoColors.neutral[600],
      },
      tables: {
        backgroundColor: porticoColors.neutral[300],
        color: porticoColors.neutral[600],
      },
      weekOverWeek: {
        active: {
          background: porticoColors.white,
          border: porticoColors.neutral[900],
          percentage: porticoColors.red[500],
          text: porticoColors.neutral[900],
          title: porticoColors.neutral[900],
          total: porticoColors.neutral[900],
        },
        inactive: {
          background: porticoColors.neutral[300],
          border: porticoColors.neutral[300],
          percentage: porticoColors.teal[500],
          text: porticoColors.neutral[600],
          title: porticoColors.neutral[600],
          total: porticoColors.neutral[500],
        },
      },
    },
  },
  nudgeFilter: {
    backgroundColor: {
      dark: porticoColors.blue[400],
      light: porticoColors.blue[50],
    },
    borderColor: {
      dark: porticoColors.blue[300],
      light: porticoColors.blue[600],
    },
    iconColor: {
      dark: porticoColors.blue[300],
      light: porticoColors.blue[600],
    },
  },
  nudgeFrequency: {
    backgroundColor: {
      dark: porticoColors.golden[400],
      light: porticoColors.golden[50],
    },
    borderColor: {
      dark: porticoColors.golden[200],
      light: porticoColors.golden[300],
    },
    iconColor: {
      dark: porticoColors.golden[200],
      light: porticoColors.golden[300],
    },
  },
  nudgeInteraction: {
    backgroundColors: {
      announcement: {
        dark: porticoColors.golden[400],
        light: porticoColors.golden[200],
      },
      positive: {
        dark: porticoColors.teal[400],
        light: porticoColors.teal[200],
      },
      proactive: {
        dark: porticoColors.blue[400],
        light: porticoColors.blue[200],
      },
      reactive: {
        dark: porticoColors.red[400],
        light: porticoColors.red[200],
      },
    },
    colors: {
      announcement: {
        dark: porticoColors.golden[300],
        light: porticoColors.golden[300],
      },
      positive: {
        dark: porticoColors.teal[300],
        light: porticoColors.teal[300],
      },
      proactive: {
        dark: porticoColors.blue[300],
        light: porticoColors.blue[300],
      },
      reactive: {
        dark: porticoColors.red[300],
        light: porticoColors.red[300],
      },
    },
    secondaryColors: {
      announcement: {
        dark: porticoColors.golden[300],
        light: porticoColors.golden[200],
      },
      positive: {
        dark: porticoColors.teal[300],
        light: porticoColors.teal[200],
      },
      proactive: {
        dark: porticoColors.blue[300],
        light: porticoColors.blue[200],
      },
      reactive: {
        dark: porticoColors.red[300],
        light: porticoColors.red[200],
      },
    },
  },
  overlay: {
    hover: {
      dark: porticoColors.neutral[700],
      light: porticoColors.neutral[300],
    },
    selected: {
      dark: porticoColors.neutral[600],
      light: porticoColors.neutral[350],
    },
  },
  payment: paymentColors,
  primary: {
    dark: porticoColors.teal[300],
    light: porticoColors.teal[400],
  },
  primaryBackground: {
    dark: porticoColors.teal[500],
    light: porticoColors.teal[50],
  },
  primaryForeground: {
    dark: porticoColors.teal[50],
    light: porticoColors.teal[500],
  },
  primaryText: {
    dark: porticoColors.neutral[100],
    light: porticoColors.neutral[900],
  },
  secondary: {
    dark: porticoColors.blue[300],
    light: porticoColors.blue[400],
  },
  secondaryBackground: {
    dark: porticoColors.blue[500],
    light: porticoColors.blue[50],
  },
  secondaryForeground: {
    dark: porticoColors.blue[50],
    light: porticoColors.blue[500],
  },
  secondaryText: {
    dark: porticoColors.neutral[200],
    light: porticoColors.neutral[800],
  },
  tab: {
    dark: {
      selected: {
        textColor: porticoColors.neutral[100],
      },
      textColor: porticoColors.neutral[400],
    },
    light: {
      selected: {
        textColor: porticoColors.neutral[900],
      },
      textColor: porticoColors.neutral[600],
    },
  },
  toggleButton: {
    selected: {
      backgroundColor: {
        dark: porticoColors.neutral[900],
        light: porticoColors.neutral[100],
      },
    },
  },
  warning: {
    dark: porticoColors.golden[300],
    light: porticoColors.golden[400],
  },
  warningBackground: {
    dark: porticoColors.golden[500],
    light: porticoColors.golden[50],
  },
  warningForeground: {
    dark: porticoColors.golden[50],
    light: porticoColors.golden[500],
  },
  white: porticoColors.white,
};
